import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import moment from 'moment';

import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import Dinero from 'dinero.js';
import styled from 'styled-components';

import AppState from '@webapp/store/state';
import { showMainLoader } from '@webapp/store/ui/selectors';

import MetricsWidget from '../metrics-widget';
import { AdminGetStatementResponse } from '@services/royalties/types/api/admin-get-statements-response';
import EarningsIndicator from '../metrics-widget/earnings-indicator';
import { aggregateStatements } from '@webapp/store/royalties/selectors';

interface EarningsWidgetProps {
  className?: string;
  loading: boolean;
  total: Dinero.Dinero;
  statements: AdminGetStatementResponse;
}

const mapStateToProps = (state: AppState) => ({
  loading: showMainLoader(state),
  total: state.earnings.total['ARTIST'],
  statements:
    state.royalties.artists[state.artist.active?.id || '']?.statements || [],
});

const EarningsWidget: FunctionComponent<EarningsWidgetProps> = ({
  className,
  total,
  statements,
}) => {
  const dispatch = useDispatch();
  const [filteredStatements, setFilteredStatements] =
    React.useState<AdminGetStatementResponse>([]);
  React.useEffect(() => {
    const filtered = statements.filter((statement) => {
      const statementDate = moment(`${statement.eligibleDate}-01`);
      return statementDate.isSame(moment(), 'month');
    });
    setFilteredStatements(filtered);
  }, [statements]);

  const handleClick = () => {
    dispatch(push(`/earnings`));
  };

  return (
    <MetricsWidget
      className={className || ''}
      title="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.TITLE"
      subtitle="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.SUBTITLE"
      onClick={handleClick}
    >
      <Container>
        <ReferenceWrapper>
          <EarningsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.TOTAL"
            textTop={true}
            label={total}
          />
          <EarningsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.THIS_MONTH"
            textTop={true}
            label={aggregateStatements(filteredStatements, 'earnings')}
          />
        </ReferenceWrapper>
      </Container>
    </MetricsWidget>
  );
};

export default connect(mapStateToProps)(EarningsWidget);

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

const ReferenceWrapper = styled.div`
  display: flex;
  margin: 20px auto auto 0px;
  flex-direction: row;
  justify-content: flex-end;
  gap: 40px;
  grid-column: span 3;
`;
